export default () =>
  import(/* webpackChunkName: 'coffee/app/agreement/virtual-product' */ './VirtualProduct');
